define('drops/carousel/carousel',[
    'jquery',
    'underscore',
    'lq/drop',
    'jquery.bxslider/jquery.bxslider'
], function ($, _, Drop, bxslider) {
    'use strict';

    var controls = [
        'default',
        'custom'
    ];

    var defaults = {
        data: {
            size: { x: 200, y: 150 },
            showPager: true,
            showControls: true,
            controls: 'default',
            opacity: 100,
            border: {
                width: 5,
                color: 'rgba(255, 255, 255, 1)',
                style: 'solid',
                top: true,
                left: true,
                bottom: true,
                right: true
            },
            background: {
                enabled: true,
                color: 'rgb(255, 255, 255)'
            }
        }
    };

    function Carousel(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.slideChanged = 0;

        this.sliderActive = false;
        this.onChangeFunctions = [];

        this.childDrops = _.sortBy(this.childDrops, function (child) {
            return child.data.index;
        });

        this.$shadowWrapper = $('<div />')
            .css({
                height: '100%',
                width: '100%'
            });

        this.$sliderUl = $('<ul />')
            .addClass('bxslider')
            .css({margin:'0'})
            .width(this.data.size.x)
            .height('100%')
            .appendTo(this.$shadowWrapper);

        this.$shadowWrapper.appendTo(this.$element);

        this.$element
            .addClass('boxToBorderSize')
            .css({
                opacity: Number(this.data.opacity) / 100,
                paddingBottom: '30px'
            });

        this.renderDropShadow();
    }

    Drop.extend(Carousel, Drop);

    Carousel.typeName = 'Carousel';

    Carousel.controls = controls;

    Carousel.prototype.renderDropShadow = function () {
        if (this.data.hasDrop) {
            this.$shadowWrapper
                .css({
                    boxShadow: this.data.dropSize + 'px ' + this.data.dropSize + 'px ' + this.data.dropBlur + 'px #888888'
                });
        } else {
            this.$shadowWrapper
                .css('boxShadow', 'none');
        }
    };

    Carousel.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    Carousel.prototype.render = function ($element) {
        return this.createAndRenderDrops($element);
    };

    Carousel.prototype.postRender = function () {
        _.defer(this.initSlider.bind(this));
    };

    Carousel.prototype.hasPanels = function() {
        return !!_.findWhere(this.pool, { type: 'CarouselPanel' });
    };

    Carousel.prototype.initSlider = function () {
    	var self = this;

    	var onSlideHandler = function (currentElement, currentPosition, comingPosition) {
    		self.setInitialIndex(comingPosition);
            self.slideChanged = self.slideChanged + 1;

            for (var i = 0; i < self.$sliderUl[0].childNodes.length; i++) {
                var temp = self.$sliderUl[0].childNodes[i];
                self.disableTabbing($(temp));
            }
            self.enableTabbing($(currentElement));

            return true;
    	};

    	if (this.hasPanels()) {
            self.$element.children('li').appendTo(self.$sliderUl);

	        self.slider = self.$sliderUl.bxSlider({
	            mode: 'horizontal',
	            hideControlOnEnd: true,
	            responsive: true,
	            video: true,
	            touchEnabled: true,
	            oneToOneTouch: false,

	            controls: this.data.showControls && this.data.controls === 'default',
	            pager: this.data.showPager,

    		    swipeThreshold: 100,
    		    speed: 500,
    			startSlide: self.getInitialIndex(),
    			onSlideBefore: function (currentElement, currentPosition, comingPosition) {
    				onSlideHandler(currentElement, currentPosition, comingPosition);
    				self.change();
    				return true;
    			},

    			auto: this.designData ? false : this.data.enableAutoTransition,
    			pause: this.data.autoTransitionPause * 1000,
    			infiniteLoop: this.designData ? false : this.data.enableAutoTransition,

    			onSlideNext: onSlideHandler,
    			onSlidePrev: onSlideHandler,
    			onSlideAfter: function () {
    				self.sliderActive = false;
    			}
    		});
    		self.$element.find('.bx-controls').css({ lineHeight: '1' });
            self.$element.find('.bx-viewport').height(self.data.size.y);
            self.setBorderAndBGStyle();

            for (var i = 0; i < self.$sliderUl[0].childNodes.length; i++) {
                if (i !== self.getInitialIndex() + 1) {
                    var temp = self.$sliderUl[0].childNodes[i];
                    self.disableTabbing($(temp));
                }
            }
    	}
    };

    Carousel.prototype.setBorderAndBGStyle = function () {
        var b = this.data.border; // shortening
        var bg = this.data.background; // shortening
        this.$element.find('.bx-wrapper').css({
            borderBottom: b.bottom ? b.width + 'px ' + b.style + ' ' + b.color : 'none',
            borderLeft:  b.left ? b.width + 'px ' + b.style + ' ' + b.color : 'none',
            borderTop:  b.top ? b.width + 'px ' + b.style + ' ' + b.color : 'none',
            borderRight: b.right ? b.width + 'px ' + b.style + ' ' + b.color : 'none',
            background: bg.enabled ? bg.color : 'none'
        });
        var originalBgWidth = 5;
        var widthCorrectionAmount = 0;
        if (b.left && b.right) {
            widthCorrectionAmount = 2 * (originalBgWidth - b.width);
        } else if (b.left || b.right) {
            widthCorrectionAmount = 2 * originalBgWidth - b.width;
        } else if (!b.left && !b.right) {
            widthCorrectionAmount = 2 * originalBgWidth;
        }

        var actualWidth =this.$element.find('.bx-wrapper').css('width');

        var left = null;
        var correction = 2 * originalBgWidth;
        if (b.style === 'none' || b.style === 'hidden') {
            correction = 0;
            widthCorrectionAmount = 0;
            left = 2 * originalBgWidth;
        }

        this.$sliderUl.find('li').css({
            width: parseFloat(actualWidth) - correction + widthCorrectionAmount + 'px',
            left: left ? -left + 'px' : -widthCorrectionAmount + 'px'
        });
    };

    Carousel.prototype.disableTabbing = function ($element) {
        var self = this;
        if ($element) {
            if (!$element.prop('originalTabindex')) {
                if ($element.attr('tabindex')) {
                    $element.prop('originalTabindex', $element.attr('tabindex'));
                } else {
                    $element.prop('originalTabindex', 'undef');
                }
            }
            $element.attr('tabindex', -1);
            _.each($element[0].childNodes, function(temp) {
                self.disableTabbing($(temp));
            })
        }
    };

    Carousel.prototype.enableTabbing = function ($element) {
        var self = this;
        if ($element) {
            if ($element.prop('originalTabindex') !== 'undef') {
                $element.attr('tabindex', $element.prop('originalTabindex'));
            } else {
                $element.removeAttr('tabindex');
            }
            _.each($element[0].childNodes, function(temp) {
                self.enableTabbing($(temp));
            })
        }
    };

    Carousel.prototype.goToSlide = function (slideNr) {
    	var self = this;
        if (self.slider != undefined && self.slider.getCurrentSlide() !== slideNr) {
            self.setInitialIndex(slideNr);
            self.sliderActive = true;
            self.slider.goToSlide(slideNr);
        }
    };

    Carousel.prototype.onChange = function (func) {
        this.onChangeFunctions.push(func);
    };

    Carousel.prototype.offChange = function (func) {
        this.onChangeFunctions = _.without(this.onChangeFunctions, func);
    };

    Carousel.prototype.change = function () {
        var index = this.getInitialIndex();
        _.each(this.onChangeFunctions, function(item) {
            item(index);
        });
    };

    Carousel.prototype.setInitialIndex = function (index) {
        var parameters = this.getInitialIndexParameters();
        parameters.setValue(this.data.id, index);
    };

    Carousel.prototype.getInitialIndex = function () {
        var parameters = this.getInitialIndexParameters();
        return parameters.getValue(this.data.id) || 0;
    };

    Carousel.prototype.getInitialIndexParameters = function () {
        var parameters = this.piping.parameters;
        return this.data.useLocalParameter
            ? parameters.locals
            : parameters.globals;
    };

    Carousel.prototype.performAction = function (action) {
        if (action === 'next') this.slider.goToNextSlide();
        if (action === 'previous') this.slider.goToPrevSlide();
    };

    Carousel.prototype.canPerformAction = function (action) {
        if (this.slider) {
            if (action === 'next')
                return this.slider.getCurrentSlide() + 1 < this.slider.getSlideCount();
            if (action === 'previous')
                return this.slider.getCurrentSlide() > 0;
        } else {
            // initial state when the slider has not yet been loaded
            if (action === 'next')
                return this.hasPanels();
        }

        return false;
    };

    Carousel.prototype.unsubscribeEventHandlers = function () {
        if (this.slider) {
            this.slider.destroySlider()
            this.slider = null;
        }
    };

    return Carousel;
});
